"use client"

import React, { useEffect, useState } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import { createOrderFromCurrentBasketAction, updateOrderAfterRedirectAction } from "@/actions/basketActions"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { useTranslations } from "next-intl"

import { CheckoutContext } from "@/lib/storefront/checkout/checkout-service"
import { Button } from "@/components/ui/components"
import { UbCheckoutReviewCreateOrderButtonStoryblok } from "@/components/storyblok/component-types"

interface CheckoutReviewCreateOrderButtonProps {
  checkoutContext: CheckoutContext
  blok: UbCheckoutReviewCreateOrderButtonStoryblok
}

export default function CheckoutReviewCreateOrderButtonClient(props: CheckoutReviewCreateOrderButtonProps) {
  const t = useTranslations("storefront")
  const router = useRouter()
  const searchParams = useSearchParams()
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)
  const isB2c = !props.checkoutContext.isB2B
  const navisionId = props.checkoutContext.customerData?.navisionId

  const { customOrderId, messageToMerchant, setCreatedOrder } = useUbStorefrontState()

  useEffect(() => {
    const redirect = searchParams.get("redirect")
    const orderId = searchParams.get("orderId")
    if (redirect && orderId) {
      const params: { [key: string]: string } = {}
      searchParams.forEach((value, key) => {
        params[key] = value
      })
      updateOrderAfterRedirectAction(orderId, params).then((value) => {
        if ("success" === redirect) {
          router.push("/basket/checkout/confirmation")
        } else {
          setErrorMessage(t("order.creation.status.not_completed"))
        }
      })
    }
  }, [searchParams, router])

  function createOrder() {
    createOrderFromCurrentBasketAction(isB2c, customOrderId, navisionId, messageToMerchant).then((value) => {
      if (value?.result === "NOK") {
        console.log(value.message)
        setErrorMessage(t("order.creation.status.not_completed"))
      } else {
        const createdOrder = value?.orderData
        console.dir(createdOrder, { depth: 10 })
        if (createdOrder?.orderCreation?.status === "COMPLETED") {
          setCreatedOrder(createdOrder)
          router.push("/basket/checkout/confirmation")
        }
      }
    })
  }

  return (
    <>
      {errorMessage && <p className={"text-xs text-red-500"}>{errorMessage}</p>}
      <Button
        onClick={createOrder}
        size={"default"}
        variant={"default"}
        className={"bg-primary py-0 font-normal text-white"}
      >
        {"Kostenpflichtig Bestellen"}
      </Button>
    </>
  )
}
